module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "form-horizontal pt10px"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("上传间隔")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uploadInterval),
      expression: "uploadInterval"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.uploadInterval = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("12")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "24"
    }
  }, [_vm._v("24")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "48"
    }
  }, [_vm._v("48")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "72"
    }
  }, [_vm._v("72")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "96"
    }
  }, [_vm._v("96")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "120"
    }
  }, [_vm._v("120")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "144"
    }
  }, [_vm._v("144")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "168"
    }
  }, [_vm._v("168")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "192"
    }
  }, [_vm._v("192")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "216"
    }
  }, [_vm._v("216")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "240"
    }
  }, [_vm._v("240")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "264"
    }
  }, [_vm._v("264")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "288"
    }
  }, [_vm._v("288")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "312"
    }
  }, [_vm._v("312")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "336"
    }
  }, [_vm._v("336")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "360"
    }
  }, [_vm._v("360")])]), _vm._v(" "), _c('span', {
    staticClass: "dis_block pt5px orange_t"
  }, [_vm._v("单位小时")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v("唤醒时间")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.duration),
      expression: "duration"
    }],
    staticClass: "form-control col-sm-1 timeD",
    attrs: {
      "type": "text",
      "placeholder": "HH:MM"
    },
    domProps: {
      "value": (_vm.duration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.duration = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('span', {
    staticClass: "red pt5px"
  }, [_vm._v(_vm._s(_vm.alertMsg))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-right pt10px pr10px"
  }, [_c('button', {
    staticClass: "btn btn-primary modal-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.withdrawBtn
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary modal-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.nextClick
    }
  }, [_vm._v("下一步")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf566454","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/vehiclemonitor/instructions/InsGT740DefaultedModeSet.vue
// module id = 1638
// module chunks = 0